<template>
    <div class="pc-footer">
        <div class="footer-wrapper">
            <div class="center">
                <div class="left txt" v-show="lang === 'zh'">
                    <p>厦门办公室：厦门市思明区领事馆路7号楼</p>
                    <p>上海办公室：上海市溧阳路735号2幢3层</p>
                    <p>福州办公室：福州市五四路128号恒力城12层</p>
                </div>
                <div class="left txt" v-show="lang === 'zh'">
                    <p>电话：0591-87503376</p>
                    <p>邮箱：fulvlianxin@3Icapital.cn</p>
                </div>
                <div class="left-en txt" v-show="lang === 'en'">
                    <p>Office: Building7,No.4 Consulate Road, Siming District, Xiamen, China</p>
                    <p>Office: 3rd Floor, Building 2, No.735 Liyang Road, Hongkou District, Shanghai, China</p>
                    <p>Office: 12th Floor, Hengli City, No.128 Wusi Road, Gulou District, Fuzhou, China</p>
                </div>
                <div class="middle txt" v-show="lang === 'en'">
                    <p>Tel：0591-87503376</p>
                    <p>Email：fulvlianxin@3Icapital.cn</p>
                </div>
                <div class="right">
                    <div class="qrcode">
                        <p v-show="lang === 'zh'">
                            <span class="txt-align">扫描右侧二维码</span>
                            <span class="txt-align">关注华闽联信</span>
                        </p>
                        <p v-show="lang === 'en'">
                            <span class="txt-align">Scan & Follow Us</span>
                        </p>
                        <img src="../../assets/code.jpg" alt="">
                    </div>
                </div>
            </div>
            <div class="beian">
                <span>版权所有 © 福建华闽联信私募基金管理有限公司</span>
                <p>
                    <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">闽ICP备19024581号</a>
                    <!-- <a target="_blank"
                        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010902103759"
                        style="margin: 0 0 0 10px;"><img src="http://www.beian.gov.cn/img/new/gongan.png"
                            style="margin: 0 2px 0 0; width: 16px; vertical-align: text-bottom" alt="" />沪公网安备
                        31010902103759号</a> -->
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { Tooltip } from 'element-ui'
export default {
    components: { Tooltip },
    name: "Footer",
    data() {
        return {
        }
    },
    computed: {
        lang() {
            return this.$i18n.locale;
        }
    },

}
</script>

<style lang="less">
.pc-footer {
    margin: 0 auto;
    min-width: var(--layout-min-width);
    background-image: url('../../assets/footer_bg.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;

    .footer-wrapper {
        position: relative;
        line-height: 30px;
        padding: 2rem 15rem 0;

        margin: 0 auto;
        max-width: var(--layout-max-width);

        .fwcn {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start !important;
            margin-bottom: 46px;

            &-item {
                flex: 1;
                border-right: 1px solid #d4d4d4;
                transition: all 0.3s;

                &:last-child {
                    border-right: none;
                }

                &:hover {
                    cursor: pointer;
                    margin-top: -10px;
                }

                text-align: center;

                .icon {
                    width: 54px;
                    height: 54px;
                }

                .el-tit {
                    font-size: 18px;
                    font-weight: bold;
                }

                .el-tit-en {
                    font-weight: normal;
                    height: 60px;
                    font-size: 16px;
                    line-height: 24px;
                }
            }
        }

        .center {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: white;

            >div {
                >img {
                    width: 112px;
                }
            }

            .right {
                display: flex;
                justify-content: flex-end;

                .qrcode {
                    display: inline-block;
                    margin-right: 20px;

                    img {
                        width: 112px;
                        height: 112px;
                    }

                    text-align: right;

                    >* {
                        vertical-align: middle;
                    }

                    p {
                        display: inline-block;
                        margin-right: 20px;

                        span {
                            text-align: center;
                            display: block;
                        }
                    }
                }

                .linkin {
                    cursor: pointer;

                    img {
                        width: 112px;
                        height: 112px;
                    }
                }
            }


        }

        .beian {
            border-top: 1px solid #aaa;
            text-align: center;
            margin-top: 20px;
            padding: 10px 0;

            >* {
                display: block;
                text-align: center;
            }

            span {
                color: white;
                font-size: 12px;
                margin-right: 10px;
            }

            a {
                text-decoration: none;
                color: white;
                font-size: 12px;
            }
        }
    }
}
</style>